import { FallbackProps } from 'react-error-boundary';

import { navigate } from '@/providers';
import { AppRoutes } from '@/constants';

import { ServerErrorIcon } from '@/assets/icons';
import { Button } from '@/components/common';
import { Alert } from '@/lib/ui';

const FallbackComponent = ({ error }: FallbackProps) => {
  const copyMessage = () => {
    navigator.clipboard.writeText(`${(error as any)?.message}\n${(error as any)?.stack}`);
    Alert.success('Message copied to clipboard!');
  };

  return (
    <div className="flex flex-col items-center justify-center bg-transparent overflow-y-auto m-10">
      <ServerErrorIcon className="flex-shrink-0" />
      <h1 className="text-[32px] font-bold text-neutral-9 mt-10 mb-3 text-center">
        Uh...Oh...! Something Went Wrong
      </h1>
      <span className="font-medium text-base text-7 text-center">
        Please reload the page or copy the error message and send an email to <br /> our
        Administrator via <u>admin.smartoffice@stengg.com</u>
      </span>
      <div className="text-base font-medium text-neutral-7 border border-solid border-neutral-5 bg-neutral-3 text-center my-6 mx-8 p-5 rounded-soft h-auto">
        <div>{(error as any)?.message}</div>
        <div
          style={{
            display: '-webkit-box',
            WebkitLineClamp: 3,
            WebkitBoxOrient: 'vertical',
            overflow: 'hidden',
          }}
        >
          {(error as any)?.stack}
        </div>
      </div>
      <div className="flex items-center flex-wrap justify-center gap-3">
        <Button
          buttonColor="primary"
          buttonStyle="filled"
          size="lg"
          className="w-[208px]"
          onClick={() => navigate(AppRoutes.HOME)}
        >
          Reload Page
        </Button>
        <Button
          buttonColor="primary"
          buttonStyle="outline"
          size="lg"
          className="w-[208px]"
          onClick={copyMessage}
        >
          Copy Message
        </Button>
      </div>
    </div>
  );
};

export { FallbackComponent };
